import { types } from "../../types/types";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import axios from "axios";
import { TIPO_PRACTICAS_POR_FECHA } from "../../utils/constants";
import ContratacionesConveniosService from "../../services/ContratacionesConveniosService";
import { startAlerta } from "../ui/alertas";

//FILTROS
export const setActivosPorFecha = (activoPorFecha) => async (dispatch) => {
  dispatch({
    type: types.contratacionesConveniosSetActivosPorFecha,
    payload: activoPorFecha,
  })
}

export const limpiarConvenios = () => async (dispatch) => {
  dispatch({
    type: types.contratacionesContratoLimpiarConvenios
  })
}

// VALORIZACIONES POR PRACTICAS
export const conveniosActivosPorPractica = (codigoPractica) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerConveniosPorPracticas(getState().contrataciones.dataContrato.idEfectorFacturacion, codigoPractica);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosGetPorPracticaSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosGetPorPracticaError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las practicas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEquivalenciasNomencladores = () => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerEquivalenciasNomencladores(getState().contrataciones.dataContrato.idEfectorFacturacion);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosEquivalenciasNomencladoresGetSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.contratacionesConveniosEquivalenciasNomencladoresGetError });
      dispatch(finishSpinner());
      handleErrorApi(dispatch, error, "Error al obtener las equivalencias de nomencladores", "Ha ocurrido un error. Intente nuevamente");
    }
  };
};

export const generateExcelEquivalencias = (idEfectorFacturacion) => async (dispatch) => {

  dispatch(startSpinner());
  try {
    const response = await ContratacionesConveniosService.generarExcelEquivalencias(idEfectorFacturacion);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Reporte Equivalencias Nomencladores - ${idEfectorFacturacion}.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};


// NOMENCLADOS
export const conveniosTraerCapitulos = () => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesConveniosService.traerCapitulos();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesConveniosTraerCapitulos,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los capitulos",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const conveniosPrevisualizacion = (data, setShowPrevisualizacion) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const idEfectorFacturacion = getState().contrataciones.dataContrato.idEfectorFacturacion;
    const result = await ContratacionesConveniosService.enviarPrevisualizacion(idEfectorFacturacion, data);
    const body = await result.json();
    if (result.ok) {
      dispatch({
        type: types.contratacionesConveniosPrevisualizacionSuccess,
        payload: body,
      });
      setShowPrevisualizacion(true);
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesConveniosPrevisualizacionError });
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al enviar capitulos para previsualización",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const conveniosConfirmarPracticas = (data, closeModalPracticasHandler) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.enviarPracticasConfirmadas(
        data,
        data.idEfectorFacturacion
      );
      const body = await result.json();
      if (result.ok) {
        closeModalPracticasHandler();
        dispatch(conveniosGetPracticasConfirmadas(data.idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar practicas confirmadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosGetPracticasConfirmadas = (idEfectorFacturacion,
  tipoGalenosGastosPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES,
  codDesdeFiltro, codHastaFiltro,
  fechaDesde, fechaHasta) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerGalenosGastosCargados(
        idEfectorFacturacion,
        tipoGalenosGastosPorFecha,
        codDesdeFiltro,
        codHastaFiltro,
        fechaDesde,
        fechaHasta
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosGetPracticasConfirmadasSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosGetPracticasConfirmadasError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas confirmadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNomencladosMasivo = (idEfectorFacturacion,
  valorizaciones,
  fechaFin,
  eliminacionPerm,
  setSelected
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarPracticaActivaNomencladosMasivas(
        { valorizaciones, fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosGetPracticasConfirmadas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        dispatch(startAlerta("Practica eliminada correctamente", "success"))
        setSelected && setSelected([]);
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNomenclados = (idEfectorFacturacion, idPractica, fechaFin,
  eliminacionPerm) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result =
        await ContratacionesConveniosService.eliminarPracticaActivaNomenclados(
          idPractica,
          { fechaFin, eliminacionPerm }
        );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosGetPracticasConfirmadas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        dispatch(startAlerta("Practica eliminada correctamente", "success"))

      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosReactivarPracticaNomenclados = (idEfectorFacturacion, idPractica) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result =
        await ContratacionesConveniosService.reactivarPracticaNomenclados(
          idPractica
        );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosGetPracticasConfirmadas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al reactivar practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEditarNomenclados = (idEfectorFacturacion, idValorizacion, data) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.editarNomenclados(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosGetPracticasConfirmadas(idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

// VALOR FIJO
export const conveniosValorFijoGetPracticas = (data, setShowTable) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPracticasValorFijo(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosValorFijoGetPracticasSuccess,
          payload: body,
        });
        setShowTable(true);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosValorFijoGetPracticasError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas de valor fijo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosValorFijoGetPracticasActivas = (idEfectorFacturacion,
  tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES,
  codDesdeFiltro, codHastaFiltro,
  fechaDesde, fechaHasta) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPracticasActivasValorFijo(idEfectorFacturacion,
        tipoPracticasPorFecha,
        codDesdeFiltro,
        codHastaFiltro,
        fechaDesde,
        fechaHasta
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosValorFijoGetPracticasActivasSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosValorFijoGetPracticasActivasError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas activas de valor fijo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosValorFijoPostPracticas = (
  data,
  setShowTable,
  resetForm
) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result =
        await ContratacionesConveniosService.enviarPracticasActivasValorFijo(data);
      const body = await result.json();
      if (result.ok) {
        setShowTable(false);
        resetForm();
        dispatch(
          conveniosValorFijoGetPracticasActivas(data.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar practicas de valor fijo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasValorFijoMasivo = (
  idEfectorFacturacion,
  valorizaciones,
  fechaFin,
  eliminacionPerm,
  setSelected
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;

      const result = await ContratacionesConveniosService.eliminarPracticaActivasMasivas(
        { valorizaciones, fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosValorFijoGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        dispatch(startAlerta("Practica eliminada correctamente", "success"))
        setSelected && setSelected([]);
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasValorFijo = (
  idEfectorFacturacion,
  idPractica,
  fechaFin,
  eliminacionPerm
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;

      const result = await ContratacionesConveniosService.eliminarPracticaActivas(
        idPractica,
        { fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosValorFijoGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        dispatch(startAlerta("Practica eliminada correctamente", "success"))
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosReactivarPracticaValorFijo = (
  idEfectorFacturacion,
  idPractica
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;

      const result = await ContratacionesConveniosService.reactivarPractica(
        idPractica
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosValorFijoGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al REACTIVAR practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEditarValorFijo = (
  idEfectorFacturacion,
  idValorizacion,
  data
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.editarPractica(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosValorFijoGetPracticasActivas(idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

// NNX
export const conveniosNNXGetPracticas = (data, setShowTable) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPracticasNNX(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosNNXGetPracticasSuccess,
          payload: body,
        });
        setShowTable(true);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.contratacionesConveniosNNXGetPracticasError });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas de NNX",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosNNXGetPracticasActivas = (idEfectorFacturacion,
  tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES,
  codDesdeFiltro, codHastaFiltro,
  fechaDesde, fechaHasta) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPracticasActivasNNX(
        idEfectorFacturacion,
        tipoPracticasPorFecha,
        codDesdeFiltro,
        codHastaFiltro,
        fechaDesde,
        fechaHasta
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosNNXGetPracticasActivasSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosNNXGetPracticasActivasError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas activas de NNX",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosNNXPostPracticas = (data, setShowTable, resetForm) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.enviarPracticasActivasNNX(
        data
      );
      const body = await result.json();
      if (result.ok) {
        setShowTable(false);
        resetForm();
        dispatch(conveniosNNXGetPracticasActivas(data.idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar practicas de NNX",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNNXMasivo = (
  idEfectorFacturacion,
  valorizaciones,
  fechaFin,
  eliminacionPerm,
  setSelected
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarPracticaActivasMasivas(
        { valorizaciones, fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNNXGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        setSelected && setSelected([]);
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNNX = (
  idEfectorFacturacion,
  idPractica,
  fechaFin,
  eliminacionPerm
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarPracticaActivas(
        idPractica,
        { fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNNXGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosReactivarPracticaNNX = (
  idEfectorFacturacion,
  idPractica
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;

      const result = await ContratacionesConveniosService.reactivarPractica(
        idPractica
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNNXGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al REACTIVAR practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEditarNnx = (
  idEfectorFacturacion,
  idValorizacion,
  data
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.editarPractica(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNNXGetPracticasActivas(idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

// NBU
export const conveniosNBUGetPracticas = (data, setShowTable) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPracticasNBU(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosNBUGetPracticasSuccess,
          payload: body,
        });
        setShowTable(true);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.contratacionesConveniosNBUGetPracticasError });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas de NBU",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosNBUGetPracticasActivas = (idEfectorFacturacion,
  tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES,
  codDesdeFiltro, codHastaFiltro,
  fechaDesde, fechaHasta) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      
      const result = await ContratacionesConveniosService.traerPracticasActivasNBU(
        idEfectorFacturacion,
        tipoPracticasPorFecha,
        codDesdeFiltro,
        codHastaFiltro,
        fechaDesde,
        fechaHasta
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosNBUGetPracticasActivasSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosNBUGetPracticasActivasError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir practicas activas de NBU",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosNBUPostPracticas = (data, setShowTable, reset) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.enviarPracticasActivasNBU(
        data
      );
      const body = await result.json();
      if (result.ok) {
        setShowTable(false);
        dispatch(conveniosNBUGetPracticasActivas(data.idEfectorFacturacion));
        reset();
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar practicas de NBU",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNBUMasivo = (
  idEfectorFacturacion,
  valorizaciones,
  fechaFin,
  eliminacionPerm,
  setSelected
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarPracticaActivasMasivas(
        { valorizaciones, fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNBUGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
        setSelected && setSelected([]);
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarPracticaActivasNBU = (
  idEfectorFacturacion,
  idPractica,
  fechaFin,
  eliminacionPerm
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarPracticaActivas(
        idPractica,
        { fechaFin, eliminacionPerm }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNBUGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica activa",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosReactivarPracticaNBU = (
  idEfectorFacturacion,
  idPractica
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;

      const result = await ContratacionesConveniosService.reactivarPractica(
        idPractica
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNBUGetPracticasActivas(idEfectorFacturacion, activosPorFecha));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al REACTIVAR practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEditarNbu = (
  idEfectorFacturacion,
  idValorizacion,
  data
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.editarPractica(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosNBUGetPracticasActivas(idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar practica",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosModulosGetActivos = (idEfectorFacturacion, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerModulosActivos(idEfectorFacturacion, tipoPracticasPorFecha);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosModulosGetActivosSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosModulosGetActivosError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir los modulos activos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosModulosGetCarga = (data, setShowTable) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerModulosCarga(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosModulosCargaSuccess,
          payload: body,
        });
        setShowTable(true);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosModulosCargaError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir los modulos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosModulosPost = (
  data,
  handleAfter
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { dataContrato } = getState().contrataciones;

      const result =
        await ContratacionesConveniosService.enviarModulo(dataContrato.idEfectorFacturacion, data);
      const body = await result.json();
      if (result.ok) {
        handleAfter()
        dispatch(
          conveniosModulosGetActivos(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar los modulos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEliminarModulo = (
  idEfectorFacturacion,
  idValorizacion
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.eliminarModulo(
        idValorizacion
      );
      const body = await result.json();
      if (result.ok) {
        conveniosModulosGetActivos(idEfectorFacturacion, activosPorFecha);
        dispatch(finishSpinner());
        dispatch(startAlerta("Modulo eliminado correctamente", "success"))

      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar modulo activo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosReactivarModulo = (
  idEfectorFacturacion,
  idValorizacion
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activosPorFecha } = getState().contratacionesConvenios;
      const result = await ContratacionesConveniosService.reactivarModulo(
        idValorizacion
      );
      const body = await result.json();
      if (result.ok) {
        conveniosModulosGetActivos(idEfectorFacturacion, activosPorFecha);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al reactivar modulo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosEditarModulo = (
  idEfectorFacturacion,
  idValorizacion,
  data
) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.editarModulo(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosModulosGetActivos(idEfectorFacturacion));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar modulo",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//PRESUPUESTOS
/*
export const getConveniosPresupuestos = (idEfectorFacturacion, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = process.env.REACT_APP_ENVIRONMENT === 'production' ?
        await ContratacionesConveniosService.traerPresupuestosSinAutorizacionesActivos(idEfectorFacturacion, tipoPracticasPorFecha) :
        await ContratacionesConveniosService.traerPresupuestosActivos(idEfectorFacturacion, tipoPracticasPorFecha);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosPresupuestosGetActivosSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosPresupuestosGetActivosError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir los presupuestos activos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
*/

export const getConveniosPresupuestosPortal = (idEfectorFacturacion, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.NO_VIGENTES) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPresupuestosPortal(idEfectorFacturacion, tipoPracticasPorFecha);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosPresupuestosGetActivosSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosPresupuestosGetActivosError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir los presupuestos activos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getConveniosPresupuestos = (idEfectorFacturacion, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.traerPresupuestos(idEfectorFacturacion, tipoPracticasPorFecha);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.contratacionesConveniosPresupuestosGetActivosSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({
        type: types.contratacionesConveniosPresupuestosGetActivosError,
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al recibir los presupuestos activos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const limpiarConveniosPresupuestos = () => async (dispatch) => {
  dispatch({
    type: types.contratacionesConveniosPresupuestosGetActivosError
  })
}

export const conveniosCargarPrespuesto = (data, handleAfter) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { dataContrato } = getState().contrataciones;
      const result = process.env.REACT_APP_ENVIRONMENT === 'production' ? await ContratacionesConveniosService.cargarPresupuestoSinAutorizaciones(dataContrato.idEfectorFacturacion, data) : await ContratacionesConveniosService.cargarPresupuesto(dataContrato.idEfectorFacturacion, data);

      const body = await result.json();
      if (result.ok) {
        handleAfter();
        dispatch(
          getConveniosPresupuestos(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
        dispatch(startAlerta("Presupuesto cargado correctamente", "success"))
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar el presupuesto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const conveniosModificarPrespuesto = (id, setOpen, data) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { dataContrato } = getState().contrataciones;
      const result = await ContratacionesConveniosService.modificarPresupuesto(id, data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          getConveniosPresupuestos(dataContrato.idEfectorFacturacion)
        );
        setOpen(false);
        dispatch(finishSpinner());
        dispatch(startAlerta("Presupuesto editado correctamente", "success"));
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar el presupuesto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

// TRACKING PRESUPUESTO
export const getTrackingPresupuestoContratos = (idPresupuesto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await ContratacionesConveniosService.getTrackingPresupuesto(
        idPresupuesto
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.contratacionesGetTrackingPresupuestoSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.contratacionesGetTrackingPresupuestoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//AUMENTO POR PORCENTAJE
export const conveniosAumento = (data, handleAfter) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { dataContrato } = getState().contrataciones;
      const idEfectorFacturacion = dataContrato.idEfectorFacturacion;
      const result = await ContratacionesConveniosService.setearAumentoConvenios(idEfectorFacturacion, data);
      const body = await result.json();
      if (result.ok) {
        dispatch(conveniosValorFijoGetPracticasActivas(idEfectorFacturacion));
        dispatch(finishSpinner());
        handleAfter()
        dispatch(startAlerta("Aumento de convenio exitoso", 'success'))
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al setear el porcentaje de aumento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

// PLANTILLA
const baseUrl = process.env.REACT_APP_API_URL;

export const SubirArchivoExcel = (file) => async (dispatch, getState) => {
  dispatch(startSpinner());
  const { dataContrato } = getState().contrataciones;
  const idEfectorFacturacion = dataContrato.idEfectorFacturacion;
  const url = `${baseUrl}/Valorizaciones/CargaExcel/${idEfectorFacturacion}`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;

  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  }
  const formData = new FormData();
  formData.append("formFile", file);
  try {
    const result = await fetch(url, {
      method: "POST",
      body: formData,
      headers: httpHeaders,
    });
    const body = await result.json();
    if (result.ok) {
      dispatch(finishSpinner());
      dispatch(startAlerta(`Archivo subido correctamente`, 'success', 'Comando Exitoso'));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente",
      false
    );
  }
};

export const DescargarPlantillaExcel = () => async (dispatch, getState) => {
  const { dataContrato } = getState().contrataciones;
  const url = `${process.env.REACT_APP_URL}/public-templates/Planilla-Carga-Convenios.xls`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;
  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: httpHeaders,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `PlantillaExcel-Contrato-${dataContrato.idEfectorFacturacion}.xls`);
      document.body.appendChild(link);
      link.click();
    });
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

//Reportes Convenios

export const generateExcelValorizaciones = (idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES) => async (dispatch) => {

  dispatch(startSpinner());
  try {
    const response = await ContratacionesConveniosService.generarExcelValorizaciones(idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `Reporte Valorizaciones - ${idEfectorFacturacion}.xlsx`;
      a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generatePDFValorizaciones = (idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha = TIPO_PRACTICAS_POR_FECHA.VIGENTES) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesConveniosService.generarPDFValorizaciones(idEfectorFacturacion, idTipoNomenclador, tipoPracticasPorFecha);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};
